import React from 'react';
import styles from './Performance.module.css';

interface CCLFComponent extends React.FC {
  title?: string;
}

const CCLF: CCLFComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Metric Description</div>
        <p>
          One of the worst curbside experiences a customer can have is to be unsure if the store is actually working on bringing their order outside. Leaving the customer in limbo for 3 minutes or more is considered failure to claim by the store. This metric is calculated by dividing the total number of Enhanced Curbside orders that are claimed more than 3 minutes after customer check-in or never claimed at all by the total number of Enhanced Curbside orders.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Supporting Details</div>
        <p>
          Login to ALP prior to clicking the course name or copy &amp; paste the course name below into the search field in ALP once you&apos;ve logged in:
        </p>
        <p>
          <a 
            href="https://acehardware.sabacloud.com/Saba/Web_spf/NA9P1PRD003/app/me/learningeventdetail/cours000000000273743?regId=regdw000000005275005" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Acehardware.com Enhanced Curbside Pick-up
          </a>
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Goal</div>
        <p>
          0% (no orders are claimed by the store in greater than 3 minutes from customer check-in)
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Update Cadence</div>
        <p>
          Metric is current state and updated monthly.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Learn More</div>
        <p>
          Designate a &apos;point person&apos; for each shift dedicated to fulfilling .com orders. Using a Mobile device with audible alerting and push notifications ensures you can &quot;answer the call&quot; immediately &amp; seamlessly. Managing speed &amp; inventory accuracy can directly reduce .com order cancellations &amp; elevate a best-in-class web-to-store experience. Stores must validate new orders quickly &amp; maintain consistent &amp; disciplined inventory management.
        </p>
        <br/>
        <p>
          For additional guidance review the{' '}
          <a 
            href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ace Way of Retailing acehardware.com fulfillment Store Procedures
          </a>
        </p>
      </div>
    </div>
  );
};

CCLF.title = 'Enhanced Curbside Orders Failed to Claim';
export default CCLF;
